import { render } from "./Pasteles.vue?vue&type=template&id=2f9deed4"
import script from "./Pasteles.vue?vue&type=script&lang=js"
export * from "./Pasteles.vue?vue&type=script&lang=js"

import "./Pasteles.vue?vue&type=style&index=0&id=2f9deed4&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__